import dayjs from "dayjs";
import { auth } from "../firebase";
import ENV from "../env";
export async function ticketingDashboardRequest(path, parameters, method = "GET") {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw Object.assign(new Error("Authentication required"), { status: 401 });
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), ["summary", "recipients"].includes(path) ? 270000 : 30000);
  try {
    const response = await fetch(
      `${ENV.firebaseApiUrl}/ticketing/dashboard/${path}${method === "GET" ? `?${new URLSearchParams(Object.entries(parameters).filter(([, value]) => value != null))}` : ""}`,
      {
        signal: controller.signal,
        method,
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        ...(method === "GET" ? {} : { body: JSON.stringify(parameters) }),
      },
    );
    const data = await response.json().catch((error) => {
      if (error.name === "AbortError") throw error;
      return {};
    });
    if (!response.ok)
      throw Object.assign(new Error(data?.error || "Dashboard request failed"), {
        status: response.status,
      });
    return data;
  } catch (error) {
    if (error.name === "AbortError")
      throw Object.assign(new Error("Dashboard request timed out"), { status: 408 });
    throw error;
  } finally {
    clearTimeout(timeout);
  }
}

// Local labels can repeat when daylight saving time ends. Preserve the existing
// graph's local-hour grouping instead of rendering duplicate X-axis labels.
export function dashboardChartPoints(items) {
  const values = new Map();
  items.forEach((item) => {
    const date = dayjs(item.timestamp).format("YYYY-MM-DD HH");
    values.set(date, (values.get(date) || 0) + Number(item.value || 0));
  });
  return [...values].map(([date, value1]) => ({ date, value1 }));
}

// An empty selection keeps the existing global series (also supports an older backend).
export function dashboardChartItems(summary, chartType, scanner = '') {
  if (chartType !== 'ticketScannedPerDay' || !scanner) return summary?.charts?.[chartType] || [];
  return summary?.scanUsers?.find(user => JSON.stringify(user.uid) === scanner)?.items || [];
}
